/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Options_Extended_TitleInputs */

const en_export_power_point_options_extended_title = /** @type {(inputs: Export_Power_Point_Options_Extended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extended`)
};

const de_export_power_point_options_extended_title = /** @type {(inputs: Export_Power_Point_Options_Extended_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweitert`)
};

/**
* | output |
* | --- |
* | "Extended" |
*
* @param {Export_Power_Point_Options_Extended_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_options_extended_title = /** @type {((inputs?: Export_Power_Point_Options_Extended_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Options_Extended_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_options_extended_title(inputs)
	return de_export_power_point_options_extended_title(inputs)
});